import { Leaf } from "lucide-react";

/**
 * SCHOCK MARKT — Logotype
 * Red "SCHOCK" + leaf accent (between O and C visually placed near logotype),
 * green/yellow "MARKT" subtitle. Inspired by the brand reference image.
 */
export default function BrandLogo({ variant = "dark", className = "" }) {
    const isLight = variant === "light";
    const main = isLight ? "text-white" : "text-brand-red";
    const sub = isLight ? "text-brand-yellow" : "text-brand-green";

    return (
        <div className={`inline-flex items-center gap-2 leading-none ${className}`}>
            <div className="flex flex-col items-start">
                <div className={`flex items-center font-display font-extrabold tracking-tight ${main}`}>
                    <span className="text-[24px] md:text-[26px]">SCH</span>
                    <span className="relative inline-flex">
                        <Leaf
                            className={`absolute -top-1 left-1/2 -translate-x-1/2 h-3 w-3 ${
                                isLight ? "text-brand-green" : "text-brand-green"
                            } rotate-45`}
                            strokeWidth={2.5}
                        />
                        <span className="text-[24px] md:text-[26px]">O</span>
                    </span>
                    <span className="text-[24px] md:text-[26px]">CK</span>
                </div>
                <div className={`mt-0.5 flex items-center gap-1.5 font-display text-[10px] font-semibold tracking-[0.32em] uppercase ${sub}`}>
                    <span className="block h-px w-3 bg-current opacity-50" />
                    Markt
                    <span className="block h-px w-3 bg-current opacity-50" />
                </div>
            </div>
        </div>
    );
}
